//Styles
import { useCallback, useRef, useState } from "react";
import BaseNativeAppContainer from "../base-native-app-container/BaseNativeAppContainer";
import Styles from "./PhotoBooth.module.scss";

import { ReactComponent as CapctureIcon } from "../../icons/app/capture.svg"

import Webcam from 'react-webcam';
import { APP_KEY_IDS } from "../../constants/constants";
// import { macLibraryImages } from "../gallery/Gallery";


//Redux
import { openWindow } from "../../actions";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";

import { addImage } from "../../actions/gallery";
import handleLibraryImages from "../../reducers/gallery";

const PhotoBooth = () => {

    const [img, setImg] = useState<any>("")
    const dispatch = useDispatch()
    const pictureClickTypes = [
        {
            id: 0,
            icon: <CapctureIcon />
        },
        {
            id: 1,
            icon: <CapctureIcon />
        },
        {
            id: 2,
            icon: <CapctureIcon />
        }
    ]

    const macLibraryImages = useSelector((state:RootStateOrAny)=>state.handleLibraryImages)

    const [buttonIcon, setButton] = useState(0)

    const webcamRef = useRef<any>(null);

    const videoConstraints = {
        width: 980,
        height: 800,
        imageSmoothing:true,
        facingMode: "user",
    };

    const capture = useCallback(() => {
        if (webcamRef.current != null) {
            const imageSrc = webcamRef.current.getScreenshot();
            dispatch(addImage(imageSrc))
            setImg(imageSrc);
        }
    }, [webcamRef]);


    return (
        <BaseNativeAppContainer
            appId={APP_KEY_IDS.CAMERA}
            loadFromX={30}
            width={900}
            height={700}
            MainScreen={
                <div className={Styles.camera_content}>
                    <Webcam className={Styles.video_stream}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        videoConstraints={videoConstraints}
                    />
                    <div className={Styles.bottom_sheet}>
                        <div className={Styles.cta}>
                            <div className={Styles.button} onClick={capture}>
                                {pictureClickTypes[buttonIcon].icon}
                            </div>
                        </div>
                        <div className={Styles.captured_image} onClick={()=>{dispatch(openWindow((APP_KEY_IDS.GALLERY)))}} >
                            <img src={img || macLibraryImages[0]} alt="screenshot" />
                        </div>
                    </div>
                </div >
            } title={"PhotoBooth"}
        />
    )
}

export default PhotoBooth
